const Footer = () => {
  return (
    <footer className="border-t border-border mt-10">
      <div className="container mx-auto px-4 py-8 flex flex-col md:flex-row items-center md:items-start justify-between gap-6 text-sm">
        <div className="text-muted-foreground max-w-sm text-center md:text-left">
          <p>Propulsé par <a href="https://beemm.io" target="_blank" rel="noreferrer" className="font-semibold text-primary underline-offset-4 hover:underline">Beemm.io</a>. IA pour des rendus photo naturels.</p>
          <p className="mt-2">© {new Date().getFullYear()} Beemm. Tous droits réservés.</p>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-4 text-muted-foreground">
          <a href="/" className="hover:text-foreground">Accueil</a>
          <a href="/editor" className="hover:text-foreground">Éditeur</a>
          <a href="/gallery" className="hover:text-foreground">Galerie</a>
          <a href="#pricing" className="hover:text-foreground">Tarifs</a>
          <a href="#faq" className="hover:text-foreground">FAQ</a>
          <a href="#contact" className="hover:text-foreground">Contact</a>
          <a href="/legal" className="hover:text-foreground">Mentions légales & CGU</a>
          <a href="/cookies" className="hover:text-foreground">Préférences cookies</a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;


